import React from 'react'
import MessageUtils from '../../util/MessageUtils'

const MessageUI = ({className, label, messageList, messageKey, args}) =>
  <React.Fragment>
    {
      messageList &&
      <span
        className={`${messageKey} ${className ? className : ''}`}
        dangerouslySetInnerHTML={{ __html: MessageUtils.getMessageValue(messageList, messageKey, args) }}
      >
      </span>
    }
    {
      label &&
      <span>{label}</span>
    }
  </React.Fragment>

export default MessageUI
